import React from 'react'
import Footer from '../Footer'
import RogerTwo from '../RogerTwo'

function Roger2() {
    window.scrollTo(0,0);
    return (
        <div>
            <RogerTwo/>
            <Footer/>
        </div>
    )
}

export default Roger2
